import React from "react";
import SEO from "../components/seo/SEO";
import Navigation from "../components/landing/Navigation";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";

export default function KontaktPage() {
    return (
        <div className="relative bg-nova-black text-white overflow-hidden">
            <SEO
                title="Kontakt — KB MUSIC"
                description="Kontaktujte KB MUSIC pre nezáväznú cenovú ponuku na ozvučenie, osvetlenie alebo technickú produkciu vášho eventu. Odpovieme do 24 hodín."
                canonical="/kontakt"
            />
            <Navigation />
            <div className="pt-20">
                <Contact />
            </div>
            <Footer />
        </div>
    );
}
